import React from 'react';
import { IconButton, Box } from '@mui/material';
import theme from '../../theme';
import pinIcon from '../../assets/pin_b3.svg';
import pinOutlinedIcon from '../../assets/pin_outlined_b3.svg';

const PinButton = ({ isPinned, onToggle }) => {
  return (
    <IconButton
      disableRipple
      onClick={onToggle}
      aria-label="toggle pin"
      sx={{
        width: { xs: 32, md: 40 },
        height: { xs: 32, md: 40 },
        p: 1,
        border: `1px solid ${theme.palette.grey.line}`,
        borderRadius: 1,
      }}
    >
      <Box
        component="img"
        src={isPinned ? pinIcon : pinOutlinedIcon}
        alt="pin icon"
        sx={{
          width: { xs: 16, md: 24 },
          height: { xs: 16, md: 24 },
        }}
      />
    </IconButton>
  );
};

export default PinButton;
